export const environment = {
  production: true,
  versionCheckURL: './version.json',
  apiUrl: 'https://curapatient.prd.wg.curapatient.com',
  webUrl: 'https://vaccine.walgreens.com',
  apiSocketUrl: 'https://curapatient-socket.prd.wg.curapatient.com',
  apiAuthUrl: 'https://kcprodwg.curapatient.com',
  ssoLogoutUrl: 'https://sso.walgreens.com/idp/idpLogout?TargetResource=',
  name: 'walgreens-prod',
  defaultPODClinicId: 'b0d42808-95fe-44d4-ad6c-3f93792cdb77',
  carePlanId: 1314,
  wgCareplanIdArray: [1314,41130, 41129, 41131],
  // ltcfCarePlanId : 1314,
  ltcfCarePlanId : 46183,
  ltcfDayoffAssessmentID: 339,
  patientRegistration: {
    assessmentId: 338,
    organizationId: 'e88ed8a5-e28b-4e01-99a7-dc44dc44920f',
  },
  walgreenHeadquarterId: 'da84915b-0be0-4ec7-adac-96516227be65',
  carePlans: [
    {name: 'COVID-19 Vaccine', type: 'vaccine'},
    {name: 'COVID-19 Vaccine 3rd Dose', type: 'thirdDose'},
    {name: 'COVID-19 Vaccine 3rd Dose', type: 'boosterDose', goalName: 'Dose Booster'},
    {name: 'Flu Shot Care Plan', type: 'fluShot'},
  ],
  tableauDashboardView: 'VaccinationDashboard-Walgreens/VaccinationDashboard'
};
